// extracted by mini-css-extract-plugin
module.exports = {"ctaText":"yk-LI","root":"_2bBTu","banner":"_26GdY","dark":"aMJad","icon":"_1C811","detail":"_2Opl_","title":"_3chhr","cta":"_2vF8N"};